/* bs-pro-bestsellers — tabs por categoría de la landing PROFESIONALES/B2B (Bienestar Senior).

   Cada bloque "tab" del schema tiene su propio panel de productos ya renderizado
   server-side ([data-bs-pro-tab-panel="i"]). Al activar un tab se muestra su panel y se
   ocultan los demás con el atributo nativo `hidden` — sin fetch, sin animación (no aplica
   la regla de "display:block siempre" del checklist, esa es para drawers/modales que
   animan; aquí no hay transición de apertura).

   Patrón WAI-ARIA Tab con activación manual:
     - Click en un tab lo activa.
     - Flechas Izq/Der mueven el foco entre tabs (circular) y los activan (Home/End a los
       extremos), igual que tab-accessibility.mdc.
   Guard + delegación scoped a la section (R44-R48), init en DOMContentLoaded/load y
   shopify:section:load (mismo patrón que bs-product-reviews.js). */

(function () {
  'use strict';

  function activateTab(section, index) {
    var indexStr = String(index);
    var tabs = section.querySelectorAll('[data-bs-pro-tab]');
    var panels = section.querySelectorAll('[data-bs-pro-tab-panel]');

    tabs.forEach(function (tab) {
      var isActive = tab.dataset.bsProTab === indexStr;
      tab.classList.toggle('bs-pro-bestsellers__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach(function (panel) {
      var isActive = panel.dataset.bsProTabPanel === indexStr;
      panel.classList.toggle('bs-pro-bestsellers__panel--active', isActive);
      panel.hidden = !isActive;
    });
  }

  function handleTabKeydown(section, event) {
    var currentTab = event.target.closest('[data-bs-pro-tab]');
    if (!currentTab || !section.contains(currentTab)) return;

    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-bs-pro-tab]'));
    var currentIndex = tabs.indexOf(currentTab);
    if (currentIndex === -1) return;

    var nextIndex = null;
    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    activateTab(section, nextIndex);
    var nextTab = tabs[nextIndex];
    if (nextTab && nextTab.focus) nextTab.focus();
  }

  function initSection(section) {
    if (section.dataset.bsProBestsellersInit) return;
    section.dataset.bsProBestsellersInit = 'true';

    /* R47: listener atado a la section (delegación), nunca a document/window */
    section.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-bs-pro-tab]');
      if (tab && section.contains(tab)) {
        activateTab(section, tab.dataset.bsProTab);
      }
    });

    section.addEventListener('keydown', function (event) {
      handleTabKeydown(section, event);
    });
  }

  function init(root) {
    var sections = (root || document).querySelectorAll('.bs-pro-bestsellers-root');
    sections.forEach(function (section) {
      initSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  window.addEventListener('load', function () {
    init();
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bs-pro-bestsellers-root');
    if (section) init(event.target);
  });
})();
